import { render, staticRenderFns } from "./SellBusinessDetails.vue?vue&type=template&id=53009d76&scoped=true&"
import script from "./SellBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./SellBusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./SellBusinessDetails.vue?vue&type=style&index=0&id=53009d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53009d76",
  null
  
)

export default component.exports